import Vue from 'vue'
import moment from 'moment'
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import {getLocaleDateDefaultFormat} from '@/utils/date'

TimeAgo.addLocale(en)
const timeAgo = new TimeAgo('en-US')

Vue.filter('moment_format', (date, format) => {
    if (moment(date).isValid()) {
        return moment(date).format(format)
    }
    return '-'
})

// US / GB(AU)
// 10/07/2021 | 07/10/2021
Vue.filter('base_local_date', date => {
    if (moment(date).isValid()) {
        return moment.utc(date).local().format(getLocaleDateDefaultFormat())
    }
    return '-'
})

Vue.filter('base_local_date_time', date => {
    if (moment(date).isValid()) {
        return moment.utc(date).local().format(getLocaleDateDefaultFormat() + ' HH:mm:ss')
    }
    return '-'
})

// 07/19
Vue.filter('card_expiry', date => {
    if (moment(date).isValid()) {
        return moment(date).format('MM') + '/' + moment(date).format('YY')
    }
    return '-'
})

// 1 min ago
Vue.filter('date_human', date => {
    if (moment(date).isValid()) {
        return timeAgo.format(new Date(moment.utc(date).local().format()))
    }
    return '-'
})
